import { render, staticRenderFns } from "./Deck.vue?vue&type=template&id=aa88a152&scoped=true&"
import script from "./Deck.vue?vue&type=script&lang=js&"
export * from "./Deck.vue?vue&type=script&lang=js&"
import style0 from "./Deck.vue?vue&type=style&index=0&id=aa88a152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa88a152",
  null
  
)

export default component.exports